// Icon set for the Settings screen, traced from the approved prototype: same
// paths, same viewBox, same stroke weights. Sizes and colours are passed in so
// the dialog can render them at 44/42px inside the tinted circle.

const base = (size, color, strokeWidth) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: color,
  strokeWidth,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
})

export const FingerprintIcon = ({ size = 44, color = '#FFC542', strokeWidth = 1.5 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" />
    <path d="M14 13.12c0 2.38 0 6.38-1 8.88" />
    <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" />
    <path d="M2 12a10 10 0 0 1 18-6" />
    <path d="M2 16h.01" />
    <path d="M21.8 16c.2-2 .13-5.35 0-6" />
    <path d="M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" />
    <path d="M8.65 22c.21-.66.45-1.32.57-2" />
    <path d="M9 6.8a6 6 0 0 1 9 5.2v2" />
  </svg>
)

export const FaceIcon = ({ size = 44, color = '#FFC542', strokeWidth = 1.5 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M3 7V5a2 2 0 0 1 2-2h2" />
    <path d="M17 3h2a2 2 0 0 1 2 2v2" />
    <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
    <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <path d="M9 9h.01" />
    <path d="M15 9h.01" />
  </svg>
)

export const AlertIcon = ({ size = 42, color = '#FC5A5A', strokeWidth = 1.5 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </svg>
)

export const BellIcon = ({ size = 42, color = '#FFC542', strokeWidth = 1.5 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.7 21a2 2 0 0 1-3.4 0" />
  </svg>
)

export const BackArrowIcon = ({ size = 22, color = '#000000', strokeWidth = 1.7 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
)

// Trailing arrow on the Settings row, marking it as a screen rather than an
// action. Mirrors with the text direction, so it points inward in Arabic.
export const ChevronIcon = ({ size = 18, color = '#44444F', strokeWidth = 1.8 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="m9 6 6 6-6 6" />
  </svg>
)

export const SettingsGearIcon = ({ size = 26, color = '#44444F', strokeWidth = 1.3 }) => (
  <svg {...base(size, color, strokeWidth)}>
    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)
